import { declareVconsoleComponent } from '/vodalys/vvuejs/declareVconsoleComponent.mjs'
 
import StepinInvitation from './StepinInvitation.vue' 

declareVconsoleComponent('stepinInvitation', StepinInvitation, 'stepin:invitation') 